module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-kominfo",
  sampangkabHost: "https://api-gateway.sampangkab.go.id/be-sampangkab/sampanganimation",
  // subdomain: "kominfo",
  googleApiUrl : 'https://www.googleapis.com',
  googleApiId : 'UCJDsZz_NhlmgNcClA_9LMjA',
  googleApiToken: 'AIzaSyBFtX3ujaHUgqLlBR8zNhIFetjF0-lFt3o',
  instagramApiUrl: 'https://graph.instagram.com',
  // anam tokens
  // instagramApiToken: 'IGQWRPdEM3TlVXakx2NDVvSmdKVEVQSGllcDFkRnN3R1I5MFNqdzUwMzYweVhKaFRkTzI2NkpUZAlR2N1NaNDEwZAlZA2VG9oNUFVOVN0M1NvbGE1OW1fdzRTeWVXVUhnYU9vME1lOGZAUTjQtc0dDNWFWdlU2bmFxVTgZD',
  // kominfo tokens
  instagramApiToken: 'IGQWRPdlZAwU0FuQWhtYXpUa2l5ZA1BzWjJRREVILXBSNEFhNC1GSXZALQllDYmlXbzlqMUxzZAm9rS0c3TUdUWjA0MGpkWXVkUTNGaUN3YS16b0JNd193b2ZAaYmlDZAWIyemo4YWp5NURVc1JfLXdGWW9nckRFRVdtRWMZD',
  encryptKey: 'Kom1nf0S3cr3tN0t352025!',
  uptimerobotURL: 'https://api.uptimerobot.com',
  uptimerobotToken: 'ur3129691-537bef30f90c9ce84d667394',
  vapidKey: 'BHab3KEb5RflJtqNAgDmpio4v8IrTIi2LW5PKC0ODqx_YQygrvMN8tfn5veU7Xtujx16C_pt1t2B4RIc6xCb7gU',
  nodeEnv : 'production'
};
